import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-edit-component-step',
  imports: [
    NgClass
  ],
  templateUrl: './edit-component-step.component.html',
  styleUrl: './edit-component-step.component.scss'
})
export class EditComponentStepComponent {
  @Output() onStepChange = new EventEmitter();
  @Input() index: number = 0;
  @Input() current: number = 0;
  @Input() model: number = 0;
  @Input() label: string | undefined;
}
